import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Segment, Tab } from 'semantic-ui-react'
import ReactLoading from 'react-loading'
import { send } from '../../helpers/requests'
import { tr } from '../../helpers/languages'
import Navbar from '../navbar'
import ParticipantExercises from '../participant-exercises'
import ParticipantJournal from '../participant-journal'
import ParticipantJournals from '../participant-journals'
import ParticipantWearingTime from '../participant-wearing-time'
import ParticipantTimeInApp from '../participant-time-in-app'
import ParticipantEducationalContent from '../participant-educational-content'
import ParticipantPerformance from '../participant-performance'
import ParticipantProfile from '../participant-profile'
import ParticipantSessions from '../participant-sessions'
import FeelDataReports from '../participant-feel-data-reports/feel-data-reports'
import Participants from '../participants'
import { actions as participants } from '../../store/actions/participants'
import { actions as reports } from '../../store/actions/reports'

class Participant extends Component {
    constructor (props) {
        super(props)
        this.sections = ['performance', 'sessions', 'cbt material']
        this.state = {
            l3h: 0,
            loading: true,
            patientid: null,
            silvercloudLink: null
        }
        this.sanitise(props.section, props.subsection)
        autoBind(this)
    }

    componentDidMount () {
        this.resize()
        this.props.resetReports()
        this.fetchParticipantDetails()
        window.addEventListener('resize', this.resize)
    }

    componentWillReceiveProps (nextProps) {
        this.sanitise(nextProps.section, nextProps.subsection)
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.resize)
    }

    // Sanitises the given section and subsection.
    sanitise (section, subsection) {
        if (_.isEmpty(section)) {
            return
        }
        if (!this.sections.includes(section)) {
            this.props.changeLocation({
                section: 'performance',
                subsection: undefined,
                module: undefined,
                item: undefined
            })
        }
        if (_.isEmpty(subsection)) {
            return
        }
        if (section === 'performance') {
            if (!['exercises', 'journals', 'wearing_time', 'time_in_app', 'educational_content'].includes(subsection)) {
                this.props.changeLocation({
                    subsection: undefined,
                    module: undefined,
                    item: undefined
                })
            }
        } else if (section === 'sessions') {
            if (!_.isEmpty(subsection)) {
                this.props.changeLocation({
                    subsection: undefined,
                    module: undefined,
                    item: undefined
                })
            }
        }
    }

    // Changes to the section with the given index.
    changeSection (index) {
        const section = index >= 0 && index < this.sections.length ? this.sections[index] : undefined
        this.props.changeLocation({ section, subsection: undefined, item: undefined })
    }

    // Changes to the subsection with the given name, and optionally to the module with the given ID.
    changeSubsection (subsection, module) {
        this.props.changeLocation({ subsection, module, item: undefined })
    }

    // Opens the item with the given ID.
    openItem (item) {
        this.props.changeLocation({ item })
    }

    // Closes any open item.
    closeItem () {
        this.props.changeLocation({ item: undefined })
    }

    // Resizes stuff.
    resize () {
        if (this.l1c && this.l2c && this.l3c) {
            const l1h = this.l1c.clientHeight
            const l2h = this.l2c.clientHeight
            this.setState({ l3h: l1h - l2h })
        }
    }

    participantProfileIsLoaded (scUrl) {
        this.setState({
            loading: false,
            patientid: this.props.match.params.id,
            silvercloudLink: scUrl
        })
    }

    /// Fetches the participant's profile.
    fetchParticipantDetails() {
        const participant_a0 = this.props.match.params.id

        // 🔍 Check Redux store first
        if (this.props.participant_details[participant_a0]) {
            console.log(`Participant ${participant_a0} already in store, skipping fetch.`)
            this.setState({
                patientid: participant_a0,
                loading: false
            })
            return
        }

        console.log('Fetching participant from API...')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${participant_a0}`
        })
        .then(response => {
            console.log('Fetched participant.')
            const data = response.data
            this.props.setParticipantDetails({ participant_a0, value: data })
            this.setState({
                patientid: participant_a0,
                loading: false
            })
        })
        .catch(error => {
            console.error(
                `Failed to fetch participant ${participant_a0}.`,
                error
            )
            this.setState({ loading: false })
        })
    }

    render () {
        console.log("participant_details:", this.props.participant_details)
        const panes = [
            {
                menuItem: tr('PERFORMANCE'),
                render: () => {
                    const subsection = this.props.subsection
                    return (
                        <Tab.Pane attached={false}>
                            {
                                subsection === 'journals' && !_.isEmpty(this.props.item) && (
                                    <ParticipantJournal
                                        id={this.props.item}
                                        onCloseItem={this.closeItem}
                                    />
                                )
                            }
                            {
                                subsection === 'journals' && _.isEmpty(this.props.item) && (
                                    <ParticipantJournals
                                        onChangeSubsection={this.changeSubsection}
                                        onOpenItem={this.openItem}
                                    />
                                )
                            }
                            {
                                subsection === 'exercises' && (
                                    <ParticipantExercises
                                        onChangeSubsection={this.changeSubsection}
                                    />
                                )
                            }
                            {
                                subsection === 'wearing_time' && (
                                    <ParticipantWearingTime
                                        onChangeSubsection={this.changeSubsection}
                                    />
                                )
                            }
                            {
                                subsection === 'time_in_app' && (
                                    <ParticipantTimeInApp
                                        onChangeSubsection={this.changeSubsection}
                                    />
                                )
                            }
                            {
                                subsection === 'educational_content' && (
                                    <ParticipantEducationalContent
                                        onChangeSubsection={this.changeSubsection}
                                    />
                                )
                            }
                            {
                                _.isEmpty(subsection) && (
                                    <ParticipantPerformance
                                        onChangeSubsection={this.changeSubsection}
                                    />
                                )
                            }
                        </Tab.Pane>
                    )
                }
            },
            {
                menuItem: tr('SESSIONS'),
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <ParticipantSessions/>
                        </Tab.Pane>
                    )
                }
            }
            ,
            {
                menuItem: tr('FEEL_DATA_REPORTS'),
                render: () => {
                    return (
                        <Tab.Pane attached={false}>
                            <FeelDataReports/>
                        </Tab.Pane>
                    )
                }
            }
        ]
        return (
            <Container className='participant'>
                <Navbar/>
                <Container className='but-navbar'>
                    <Participants
                        selectedParticipant={this.props.match.params.id}
                    />
                    <Container className='gist'>
                        <div className='l1' ref={(c) => {
                            this.l1c = c
                        }}>
                            <div className='l2' ref={(c) => {
                                this.l2c = c
                            }}>
                                {((this.state.patientid !== null && this.state.patientid !== this.props.match.params.id) || this.state.loading === false) &&
                                <ParticipantProfile
                                    onParticipantProfileIsLoaded={this.participantProfileIsLoaded}
                                />
                                }
                            </div>
                            <div className='l3' ref={(c) => {
                                this.l3c = c
                            }}
                                 style={{ height: `${this.state.l3h}px` }}>
                                {((this.state.patientid !== null && this.state.patientid !== this.props.match.params.id) || this.state.loading === false)
                                    ? <Segment className='tabs'>
                                        <Tab
                                            className='sections'
                                            menu={{ secondary: true, pointing: true }}
                                            panes={panes}
                                            activeIndex={this.sections.indexOf(this.props.section)}
                                            onTabChange={(_e, { activeIndex }) => {
                                                this.changeSection(activeIndex)
                                            }}
                                        />
                                    </Segment>
                                    : <div className='loader'>
                                        <ReactLoading type='spin' color='#444'/>
                                    </div>
                                }
                            </div>
                        </div>
                    </Container>
                </Container>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.participants.location.item,
        language: state.settings.language,
        section: state.participants.location.section,
        subsection: state.participants.location.subsection,
        participant_details: state.participants.participant_details,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    const _reports = bindActionCreators(reports, dispatch)
    return {
        changeLocation: _participants.changeLocation,
        setParticipantDetails: _participants.setParticipantDetails,
        resetReports: _reports.resetReports
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Participant))



// WEBPACK FOOTER //
// ./src/components/participant/index.js